import { render, staticRenderFns } from "./ReferenciasTabContent.vue?vue&type=template&id=2e63ea35"
import script from "./ReferenciasTabContent.vue?vue&type=script&lang=js"
export * from "./ReferenciasTabContent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports